import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, leftJoin, nullsafe, unionKey } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { CancelarFacturaModal } from "./edit/modal";

/**Muestra el modal de cancelación y cancela la factura si el usuario continua con la operación */
export async function CancelarFactura(idFactura: number, showModal: kea.ShowModalFunc): Promise<boolean> {
    const initial: models.CancelarFacturaModel = {
        Guias: [],
        MotivoCancelacion: "",
        IdFactura: idFactura,
        AcuseCancelacionSAT: null
    };
    const result = await showModal(CancelarFacturaModal, undefined, initial);
    if (result.result) {
        await resources.Factura.CancelarFactura(result.value);
        await kea.message("Factura cancelada", "Se canceló la factura con éxito", "success");
        return true;
    }
    return false;
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/cancelacion/index.tsx